/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  Autocomplete,
  Alert,
  Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Unstable_Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import { toast } from 'react-toastify';
import moment from 'moment';
import useStore from '../../states/store';
// API
import { getAccountList, getCcoListExport } from '../../api/ccoApi';
// Context
import AppConst from '../AppLayout/const';

export default function ClientCallOutExtractorModal() {
  const defaultForm = {
    account_code: { label: 'All', value: null },
    date_from: moment().startOf('month').format('YYYY-MM-DD'),
    date_to: moment().endOf('month').format('YYYY-MM-DD'),
  };
  const auth = useStore((state) => state.auth);
  const [accountOptions, setAccountOptions] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [form, setForm] = useState(defaultForm);
  const { toggleModal, onToggleModal } = useContext(AppConst.AppContext);
  const [toggle, setToggle] = useState(false);

  const handleAccountDropdown = async () => {
    const request = {
      keyword: '',
    };
    const reponse = await getAccountList(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data.map((row) => ({
        label: `${row.customer_code} - ${row.customer_name}`,
        value: row?.customer_code,
      }));

      // setAccountOptions(dropdownValue);
      setAccountOptions([{ label: 'All', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeDate = (value, name) => {
    setForm({ ...form, [name]: moment(value).format('YYYY-MM-DD') });
  };

  const handleChangeFilter = (e, row, name) => {
    setForm({ ...form, account_code: row });
  };

  const handleSumbitExport = async () => {
    try {
      toast.loading('Processing request please wait..');
      const request = {
        account_code: form?.account_code?.value,
        date_from: form?.date_from,
        date_to: form?.date_to,
        user_id: auth?.designation === 'CNC-MANAGER' ? null : auth?.user_id,
      };

      const response = await getCcoListExport(request);
      const { code, result } = response.data.response;

      if (code === '200') {
        toast.dismiss();
        toast.success(
          `File has been successfully exported: ${response?.data?.response?.file_name}`,
        );
        window.location.href = result;
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleClose = () => {
    setForm(defaultForm);
    onToggleModal(null);
    setToggle(false);
  };

  useEffect(() => {
    if (toggleModal?.url === 'report/client_call_out') {
      setToggle(true);
      handleAccountDropdown();
    }
  }, [toggleModal]);
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby='customized-dialog-title'
      open={toggle}
      fullWidth
      maxWidth='md'
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title'>
        Client Call Out
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid md={12}>
            <Autocomplete
              disablePortal={false}
              id='account_code'
              disableClearable
              fullWidth
              options={accountOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Account' />}
              size='small'
              value={form?.account_code}
              onChange={(e, newValue) => handleChangeFilter(e, newValue)}
              sx={{ backgroundColor: '#fff', marginBottom: '20px' }}
            />
          </Grid>
          <Grid md={6}>
            <DatePicker
              label='Date From'
              views={['month', 'day', 'year']}
              value={form?.date_from}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='Date From' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeDate(value, 'date_from')}
            />
          </Grid>
          <Grid md={6}>
            <DatePicker
              label='Date To'
              views={['month', 'day', 'year']}
              value={form?.date_to}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='Date To' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeDate(value, 'date_to')}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          color='success'
          loadingPosition='end'
          loading={disableButton}
          disabled={disableButton}
          onClick={() => handleSumbitExport()}
        >
          Export
        </Button>
      </DialogActions>
    </Dialog>
  );
}
